import { Component } from "react";
import ErrorPage from "../pages/ErrorPage";
import { reportClientError } from "../lib/errorTelemetry";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Local log for immediate developer visibility.
    console.error("ErrorBoundary caught:", error, errorInfo);
    // Ship to backend telemetry — Phase 3a hardening (iter 469).
    // reportClientError swallows its own errors so this is safe.
    reportClientError({
      message: error?.message || String(error) || "Unknown React error",
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
      source: "react",
    });
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          code={500}
          reason={this.state.error?.message || ""}
          onReset={this.reset}
        />
      );
    }
    return this.props.children;
  }
}
